import axios from 'axios';
import { get, remove } from '../utils/storage';
import logger from '../utils/logger';
import { MAIN_TOKEN_KEY } from '../constants';
import { auth } from '../utils/firebase';

const baseApi = axios.create({
  baseURL: "https://europe-west1-app-washer-pt.cloudfunctions.net/api",
});

baseApi.interceptors.request.use(
  async (config) => {
    // Prefer a live token from the Firebase SDK (auto-renewed) over the
    // localStorage snapshot. Falls back to localStorage if the SDK hasn't
    // initialized yet (e.g., page-load race).
    let token = null;
    const user = auth.currentUser;
    if (user) {
      try {
        token = await user.getIdToken(); // returns cached unless <5 min to expiry
      } catch (_) {}
    }
    if (!token) {
      token = get(MAIN_TOKEN_KEY);
    }
    if (token) {
      const cleanToken = typeof token === 'string' ? token.replace(/"/g, '') : token;
      config.headers.Authorization = `Bearer ${cleanToken}`;
    }

    logger.debug(config.method, config.url, {
      data: config.data,
      header: config.headers,
    });

    return config;
  },
  (error) => {
    logger.error(error);
    return Promise.reject(error);
  }
);

baseApi.interceptors.response.use(
  undefined,
  (err) => {
    if (err.response.status === 401 || err.response.status === 403 && err.response.data.error === 'Unauthorized') {
      remove(MAIN_TOKEN_KEY);
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default baseApi;
